import { useGraphQLQuery } from '@betterment/graphql';
import { Box, Card, Text } from '@betterment/samba-react';
import { CardLoader, ErrorBoundary } from '@betterment/shared-components';
import { useFeatureFlag } from '@betterment/shared-components/src/components/feature-flag/useFeatureFlag';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { EnvelopeAccountPendingOrdersDocument } from './graphql/envelopeAccountPendingOrders.generated';
import { PendingOrderTag } from './PendingOrderTag';

export const PendingOrdersCardView: React.FC = () => {
  const id = useRequiredParam('accountId');
  const { enabled: isPendingOrdersEnabled } = useFeatureFlag({
    splitName: 'retail.self_directed_after_hours_order_cancellation_q4_2025_enabled',
    context: 'pending_orders_card',
  });
  const { data } = useGraphQLQuery(EnvelopeAccountPendingOrdersDocument, { variables: { id }, throwOnError: true });
  const { account } = data || {};
  const pendingOrders = account && 'pendingOrders' in account ? account.pendingOrders : [];

  if (!isPendingOrdersEnabled) return null;
  if (!data) return <CardLoader />;
  if (!pendingOrders.length) return null;

  return (
    <Card css={{ padding: 'space.300' }}>
      <Box
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 'space.300',
        }}
      >
        <Text variant="text200" css={{ fontWeight: 'medium' }}>
          Pending orders
        </Text>
        <Box
          css={{
            backgroundColor: 'background.neutral',
            borderRadius: 'round',
            width: '28px',
            height: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: 'space.100',
          }}
        >
          <Text variant="text50">{pendingOrders.length}</Text>
        </Box>
      </Box>
      <Box
        css={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 'space.100',
        }}
      >
        {pendingOrders.map(order => (
          <PendingOrderTag item={order} key={order.financialSecurityOrderId} />
        ))}
      </Box>
    </Card>
  );
};

export const PendingOrdersCard: React.FC = () => (
  <ErrorBoundary fallbackType="none">
    <PendingOrdersCardView />
  </ErrorBoundary>
);
